module.exports = __webpack_public_path__ + "img/img3.aa946def.svg";